module.exports = __webpack_public_path__ + "static/28th-788ad0572b6be6f07541e38b119c13cf.png";